//Remember to import all layouts here
import External from './ExternalLayout.jsx';
import InternalTeacher from './InternalTeacher.jsx';
import InternalStudent from './InternalStudent.jsx';
import InternalTeacherDashboard from "./InternalTeacherDashboard.jsx";
//Also declare them here
export default {
	External,
	InternalTeacher,
	InternalStudent,
	InternalTeacherDashboard,
};
